/**
 * The complete set of SPA dialogs.
 *
 * This is deliberately metadata, not a second rendering layer: the existing
 * static templates and action routes remain the smallest safe implementation.
 * Credential dialogs use the same accessibility and style contract, but are
 * mounted lazily so their fields never coexist with resting business forms.
 */
export const MODAL_REGISTRY = [
	{ id: 'paywallModal', kind: 'entry', dismiss: 'close', mount: 'static' },
	{ id: 'submitIdeaModal', kind: 'entry', dismiss: 'close', mount: 'static' },
	{ id: 'aiCreateModal', kind: 'entry', dismiss: 'close', mount: 'static' },
	{ id: 'aiChapterLowRangeModal', kind: 'confirm', dismiss: 'actions', mount: 'static' },
	{ id: 'aiSuccessModal', kind: 'result', dismiss: 'primary-action', mount: 'static' },
	{ id: 'ideaSuccessModal', kind: 'result', dismiss: 'primary-action', mount: 'static' },
	{ id: 'verifyEmailOverlay', kind: 'result', dismiss: 'primary-action', mount: 'static' },
	{ id: 'setPasswordConfirmModal', kind: 'confirm', dismiss: 'close', mount: 'static' },
	{ id: 'cancelAutoRenewModal', kind: 'confirm', dismiss: 'close', mount: 'static' },
	{ id: 'upgradeResumeModal', kind: 'confirm', dismiss: 'actions', mount: 'static' },
	{ id: 'upgradeConfirmModal', kind: 'confirm', dismiss: 'actions', mount: 'static' },
	{ id: 'legalDocumentModal', kind: 'reader', dismiss: 'close', mount: 'static' },
	{ id: 'mermaidFullscreenModal', kind: 'reader', dismiss: 'close', mount: 'static' },
	{ id: 'communityIdeaDetailModal', kind: 'reader', dismiss: 'close', mount: 'static' },
	{ id: 'aiSubmissionDetailModal', kind: 'reader', dismiss: 'close', mount: 'static' },
	{ id: 'loginModal', kind: 'credential', dismiss: 'close', mount: 'lazy' },
	{ id: 'registerModal', kind: 'credential', dismiss: 'close', mount: 'lazy' },
	{ id: 'forgotModal', kind: 'credential', dismiss: 'close', mount: 'lazy' },
	{ id: 'oauthLinkModal', kind: 'credential', dismiss: 'close', mount: 'lazy' },
	{ id: 'resetPasswordOverlay', kind: 'credential', dismiss: 'close', mount: 'lazy' },
	{ id: 'changePasswordModal', kind: 'credential', dismiss: 'close', mount: 'lazy' },
] as const;

export type ModalId = (typeof MODAL_REGISTRY)[number]['id'];
export const modalIds: readonly string[] = MODAL_REGISTRY.map(({ id }) => id);
export const staticModalIds: readonly string[] = MODAL_REGISTRY.filter(({ mount }) => mount === 'static').map(({ id }) => id);
